"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SheetTop = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VARIANT = {
  PRIMARY: 'primary',
  PRIMARY_LIGHT: 'primaryLight',
  PRIMARY_DARK: 'primaryDark',
  SECONDARY: 'secondary',
  SECONDARY_LIGHT: 'secondaryLight',
  SECONDARY_DARK: 'secondaryDark',
  DARK: 'dark',
  LIGHT: 'light',
  SEPIA: 'sepia'
};

var SheetTop = function SheetTop(_ref) {
  var children = _ref.children,
      label = _ref.label,
      startIcon = _ref.startIcon,
      color = _ref.color,
      accessbilityAction = _ref.accessbilityAction,
      accessbilityLabel = _ref.accessbilityLabel;
  var classes = (0, _styles.useStyles)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showing = _useState2[0],
      setShowing = _useState2[1];

  var computedClassName = function computedClassName() {
    switch (color) {
      case VARIANT.PRIMARY:
        return classes.primaryVariant;

      case VARIANT.PRIMARY_LIGHT:
        return classes.primaryLightVariant;

      case VARIANT.PRIMARY_DARK:
        return classes.primaryDarkVariant;

      case VARIANT.SECONDARY:
        return classes.secondaryVariant;

      case VARIANT.SECONDARY_LIGHT:
        return classes.secondaryLightVariant;

      case VARIANT.SECONDARY_DARK:
        return classes.secondaryDarkVariant;

      default:
        return '';
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([classes.root, computedClassName()]),
    style: {
      backgroundColor: (0, _utils.checkSheetColor)(color)
    },
    onMouseEnter: function onMouseEnter() {
      return setShowing(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowing(false);
    }
  }, accessbilityAction && /*#__PURE__*/_react.default.createElement("button", {
    style: {
      height: '0px',
      width: '0px',
      padding: 0,
      margin: 0,
      position: 'absolute',
      overflow: 'hidden',
      border: 'none'
    },
    onClick: accessbilityAction,
    type: "button",
    "aria-label": accessbilityLabel
  }, accessbilityLabel), showing && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": true,
    className: classes.children
  }, children), /*#__PURE__*/_react.default.createElement("p", {
    "aria-hidden": true,
    className: classes.title,
    style: {
      color: (0, _utils.checkTextColor)(color)
    }
  }, startIcon && startIcon, " ", label));
};

exports.SheetTop = SheetTop;
SheetTop.propTypes = {
  /**
   * Conteúdo do componente
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Cor do botão
   */
  label: _propTypes.default.string.isRequired,

  /**
   * Ícone que aparecerá antes do texto
   */
  startIcon: _propTypes.default.node,

  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'primaryLight', 'primaryDark', 'secondary', 'secondaryLight', 'secondaryDark', 'light', 'dark', 'sepia']),

  /** Ação que será executada ao acionar o botão de acessibilidade, acessado
   * via TAB e leitores de tela.
   * Essa propriedade deve ser preenchida para exibir o comportamento de
   * acessibilidade
   */
  accessbilityAction: _propTypes.default.oneOfType([_propTypes.default.func, undefined]),

  /**
   * o texto que sera atrelado ao botão de acessibilidade
   */
  accessbilityLabel: _propTypes.default.string
};
SheetTop.defaultProps = {
  startIcon: null,
  color: 'secondary',
  accessbilityAction: undefined,
  accessbilityLabel: ''
};
var _default = SheetTop;
exports.default = _default;